import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppShellComponent } from './app-shell.component';

const routes: Routes = [
  {
    path: '',
    component: AppShellComponent,
    children: [
      {
        path: 'landing',
        loadChildren: () => import('../pages/landing/landing.module').then((m) => m.LandingModule),
        data: { preload: true, delay: false },
      },
      {
        path: 'create-grn',
        loadChildren: () => import('../pages/create-grn/create-grn.module').then((m) => m.CreateGrnModule),
        data: { preload: true, delay: false },
      },
      {
        path: 'storage',
        loadChildren: () => import('../pages/storage/storage.module').then((m) => m.StorageModule),
        data: { preload: true, delay: false },
      },
      {
        path: 'material-requests',
        loadChildren: () =>
          import('../pages/material-requests/material-requests.module').then((m) => m.MaterialRequestsModule),
        data: { preload: true, delay: false },
      },
      {
        path: 'transfer',
        loadChildren: () => import('../pages/transfer/transfer.module').then((m) => m.TransferModule),
        data: { preload: true, delay: false },
      },
      {
        path: '**',
        redirectTo: 'landing',
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AppShellRoutingModule {}
